//----------------------------------------------
//set the markers to the arrays
//----------------------------------------------
import { ReinosMaps } from '../../core'

ReinosMaps.prototype.searchMarker = function (mapID, marker_name, multiple) {
  const self = this

  multiple = multiple || false

  let marker = {}
  const markers = []

  //loop over the markers
  if (self.markers[mapID] !== undefined) {
    self.markers[mapID].forEach((val, key) => {

      //search the array
      if (val['keys'] !== undefined) {
        if (val['keys'].includes(marker_name)) {
          if (multiple) {
            markers.push(self.markers[mapID][key]['marker'])
          }
          else {
            marker = self.markers[mapID][key]['marker']
          }
        }
      }
    })
  }

  if (multiple) {
    return markers
  }
  else {
    return marker
  }
}
